import { useEffect, useState } from "react";
import { Button, Col, Form, Input, Row, Upload } from "antd";
import Close from "../../../components/Close";
import { beforeUpload, dummyRequest, normFile } from "../../../utils/images";
import styles from "../styles/CategoriesUI.module.css";

const CategoryEditor = ({ category, closeEditor, handleSave }) => {
  const [form] = Form.useForm();
  const [sending, setSending] = useState(false);
  const [iconPreview, setIconPreview] = useState("");
  const [selectedIconPreview, setSelectedIconPreview] = useState("");

  useEffect(() => {
    if (!category) {
      return;
    }

    setIconPreview(category.cf_image_icon2 || "");
    setSelectedIconPreview(category.cf_image_icon || "");
    form.setFieldsValue({
      id: category.id,
      name: category.name,
    });
  }, [category, form]);

  const submit = async () => {
    try {
      setSending(true);
      const values = await form.validateFields();

      const response = await handleSave({
        id: category.id,
        name: values.name,
        image1: values.image1?.length ? values.image1[0].originFileObj : category.cf_image_icon2 || "",
        image2: values.image2?.length ? values.image2[0].originFileObj : category.cf_image_icon || "",
      });

      if (response.status !== "success") {
        setSending(false);
        return;
      }

      setSending(false);
    } catch (error) {
      setSending(false);
    }
  };

  return (
    <div className={styles.editor}>
      <div className={styles.header}>
        <span className={styles.title}>Editar categoría</span>
        <Close action={closeEditor} />
      </div>
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        colon={false}
        requiredMark={false}
        className={styles.form}
        onFinish={submit}
      >
        <Row gutter={16}>
          <Col xs={24} md={8}>
            <Form.Item
              name="id"
              label={<span className={styles.label}>ID DE CATEGORÍA</span>}
            >
              <Input size="large" disabled className={styles.input} />
            </Form.Item>
          </Col>
          <Col xs={24} md={16}>
            <Form.Item
              name="name"
              label={<span className={styles.label}>NOMBRE</span>}
              rules={[{ required: true, message: "Ingresar nombre" }]}
            >
              <Input size="large" className={styles.input} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col xs={24} md={12}>
            <div className={styles.previewBlock}>
              <div className={styles.previewTitle}>Imagen icono</div>
              <div className={styles.previewCard}>
                {iconPreview ? (
                  <img src={iconPreview} alt="Icono de categoría" className={styles.previewImage} />
                ) : (
                  <span className={styles.imagePlaceholder}>Sin imagen</span>
                )}
              </div>
              <Form.Item
                name="image1"
                valuePropName="fileList"
                getValueFromEvent={normFile}
                className={styles.uploadItem}
              >
                <Upload
                  showUploadList={false}
                  customRequest={(event) => dummyRequest(event, setIconPreview)}
                  beforeUpload={beforeUpload}
                  accept="image/png,image/jpeg"
                >
                  <Button block size="large" className={styles.uploadButton}>
                    Seleccionar imagen icono
                  </Button>
                </Upload>
              </Form.Item>
            </div>
          </Col>

          <Col xs={24} md={12}>
            <div className={styles.previewBlock}>
              <div className={styles.previewTitle}>Imagen icono seleccionado</div>
              <div className={styles.previewCardWhite}>
                {selectedIconPreview ? (
                  <img
                    src={selectedIconPreview}
                    alt="Icono de categoría seleccionado"
                    className={styles.previewImage}
                  />
                ) : (
                  <span className={styles.imagePlaceholder}>Sin imagen</span>
                )}
              </div>
              <Form.Item
                name="image2"
                valuePropName="fileList"
                getValueFromEvent={normFile}
                className={styles.uploadItem}
              >
                <Upload
                  showUploadList={false}
                  customRequest={(event) => dummyRequest(event, setSelectedIconPreview)}
                  beforeUpload={beforeUpload}
                  accept="image/png,image/jpeg"
                >
                  <Button block size="large" className={styles.uploadButton}>
                    Seleccionar imagen icono seleccionado
                  </Button>
                </Upload>
              </Form.Item>
            </div>
          </Col>
        </Row>

        <div className={styles.submitWrap}>
          <Button
            loading={sending}
            className={styles.submit}
            type="primary"
            size="large"
            htmlType="submit"
          >
            GUARDAR CAMBIOS
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default CategoryEditor;
